// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pswpvudvdufidlmlrfzv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBzd3B2dWR2ZHVmaWRsbWxyZnp2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIzMzM1NzUsImV4cCI6MjA1NzkwOTU3NX0.WEa4Y0mMmyFagGEbpJnPrfRYTGBra_JzmrpvsatKlYs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);